import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=2ab71d28&scoped=true&"
import script from "./couponDetail.vue?vue&type=script&lang=js&"
export * from "./couponDetail.vue?vue&type=script&lang=js&"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=2ab71d28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab71d28",
  null
  
)

export default component.exports